import type { ReactNode } from "react";
import { Card } from "@/ui/primitives.tsx";
import { LocaleThemeBar } from "@/ui/LocaleThemeBar.tsx";
import { LogoMark } from "@/ui/Logo.tsx";
import { useAppName } from "./session.ts";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-full flex-col">
      <header className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center gap-2">
          <LogoMark size={30} />
          <span className="font-semibold">{useAppName()}</span>
        </div>
        <LocaleThemeBar />
      </header>
      <main className="flex flex-1 items-start justify-center px-4 py-8 sm:items-center">
        <Card className="w-full max-w-md">{children}</Card>
      </main>
    </div>
  );
}
